import i18next from 'i18next';
import { toast } from 'sonner';
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class GdprDashboardIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async fetchSummary() {
        try {
            const response = await this.service.getSummary();
            return { success: true, data: response.data };
        } catch (error) {
            const message = this._getErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    async openRopaReport() {
        return this._openHtmlBlob(() => this.service.getRopaReport());
    }

    async openAuditPack() {
        return this._openHtmlBlob(() => this.service.getAuditPack());
    }

    async _openHtmlBlob(fetcher) {
        try {
            const response = await fetcher();
            const blob = response.data instanceof Blob
                ? response.data
                : new Blob([response.data], { type: 'text/html;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            window.open(url, '_blank', 'noopener');
            setTimeout(() => URL.revokeObjectURL(url), 60_000);
            return { success: true };
        } catch (error) {
            const message = this._getErrorMessage(error);
            toast.error(message);
            return { success: false, error: message };
        }
    }

    _getErrorMessage(error) {
        return getIntegrationErrorMessage(error);
    }
}
